<ng-container [formGroup]="form">
  <div class="content-item-wrapper">
    <div class="drag-handle-container">
      <button type="button" mat-icon-button cdkDragHandle>
        <mat-icon svgIcon="drag-indicator"></mat-icon>
      </button>
    </div>
    <div class="content-item-body" *ngIf="getWidgetConfig(widget.type) as config">
      <ng-container [ngSwitch]="config.type">
        <ng-container *ngSwitchCase="'image'">
          <div class="header">
            <div class="title image-title">
              <image-or-icon class="inherit-size" [src]="widget.config.url"></image-or-icon>
              <div class="capitalize" trans>{{ config.name || config.type }}</div>
            </div>
            <mat-slide-toggle formControlName="active"></mat-slide-toggle>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'text'">
          <div class="header">
            <div class="title">
              <div class="capitalize centered" trans>{{ config.name || config.type }}</div>
              <div class="text-widget-body">
                <div class="text-widget-title centered">{{ widget.config.title }}</div>
                <div class="text-widget-description centered">{{ widget.config.description }}</div>
              </div>
            </div>
            <mat-slide-toggle formControlName="active"></mat-slide-toggle>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'socials'">
          <div class="header">
            <div class="title capitalize" trans>{{ config.name || config.type }}</div>
            <mat-slide-toggle formControlName="active"></mat-slide-toggle>
          </div>
          <div class="subheader">
            <social-button-list [config]="widget.config"></social-button-list>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="header">
            <div class="title capitalize" trans>{{ config.name || config.type }}</div>
            <mat-slide-toggle formControlName="active"></mat-slide-toggle>
          </div>
          <div class="subheader">
            <img
              class="favicon-img"
              [src]="settings.getAssetUrl('images/widgets/' + config.image)"
              alt=""
            />
            <span class="url">{{ widget.config.url }}</span>
          </div>
        </ng-container>
      </ng-container>
      <div class="actions">
        <button
          type="button"
          (click)="openEditWidgetDialog(widget)"
          [disabled]="editor.loading$ | async"
          class="action-button"
          mat-icon-button
          [matTooltip]="'Edit' | trans"
        >
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button
          type="button"
          (click)="editor.maybeDeleteContentItem(widget)"
          [disabled]="editor.loading$ | async"
          class="action-button delete-action"
          mat-icon-button
        >
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      </div>
    </div>
  </div>
</ng-container>
